
import { defineComponent, ref, onBeforeUnmount, onMounted, computed, watch } from 'vue'
import { useStore } from 'vuex'
import sysRequest from '@/api/sys'
import { generateNewStyle } from '@/utils/theme'
import locale from '@/i18n/lang/zh'
import 'dayjs/locale/zh-cn';
import dayjs from 'dayjs';
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import enGB from 'ant-design-vue/lib/locale-provider/en_GB';
import { displayLanguage } from '@/i18n/display'
import ugLocale from '@/i18n/component-locale'
import LanguageSelect from '@/i18n/LanguageSelect.vue'
import ImportantNotice from '@/views/components/ImportantNotice.vue'
import ActivityCoupon from '@/views/components/ActivityCoupon.vue'
import BranchAdminNotice from '@/components/BranchAdminNotice.vue'
import {applyClientSkin,resolveClientSkin} from '@/utils/clientSkin'
import '@/assets/styles/clientSkin.scss'
import store from '@/store'
import router  from '@/router'
import MaintenanceScreen from '@/components/maintenance/MaintenanceScreen.vue'
import MaintenanceTesterLogin from '@/components/maintenance/MaintenanceTesterLogin.vue'
import {createMaintenanceTester} from '@/utils/maintenanceTester'
import request from '@/utils/request'
import {message} from 'ant-design-vue'
import {installWebEntryUpdate} from '@/utils/webEntryUpdate'
import {
  DEFAULT_MAINTENANCE_CONFIG,
  loadPlatformMaintenance,
  SystemMaintenanceConfig
} from '@/utils/maintenance'
export interface Operator {
  Name: string
  Age: number
}
export default defineComponent({
  components: { LanguageSelect, MaintenanceScreen, MaintenanceTesterLogin, ImportantNotice, ActivityCoupon, BranchAdminNotice },
  setup() {
    const store = useStore()
    const person: Operator = {
      Name: 'jax ',
      Age: 34
    }
    const reconnectInterval = 5000;
    const socketRef = ref<WebSocket | null>(null);
    const initWebSocket = () => {
      const wsfapi = process.env.VUE_APP_BASE_WS + 'cus' + store.getters.userInfo.id;
      socketRef.value = new WebSocket(wsfapi);
      socketRef.value.addEventListener('open', () => {
        console.log('ws connected');
      });
      socketRef.value.addEventListener('message', (event) => {
        if(store.getters.onmessage){
          console.log('onmessage',store.getters.onmessage)
          store.getters.onmessage(event)
        }
      });

      // 关键：处理断开连接事件，触发重连
      socketRef.value.addEventListener('close', () => {
        console.log('WebSocket disconnected. Reconnecting in ' + reconnectInterval / 1000 + ' seconds...');
        setTimeout(initWebSocket, reconnectInterval); // 设置定时器进行重连
      });

      socketRef.value.addEventListener('error', (error) => {
        console.error('WebSocket error:', error);
      });
      store.state.app.socket=socketRef.value
    };
    const extractHostnameAndPort=(url)=> {  
      const urlObj = new URL(url);
      return urlObj.hostname; 
    }
    const lang=computed(() => {
      if(store.getters.language=='zh'){
        dayjs.locale('zh-cn');
        return zhCN
      }else{
        dayjs.locale(store.getters.language === 'ug' ? 'ug-cn' : 'en');
        return store.getters.language === 'ug' ? ugLocale : enGB
      }

    })
    const imgurl=computed(()=>{
      return store.getters.settings.imgurl.value
    })
    const setScale=()=>{  
      let screenWidth = window.innerWidth;  
      if (screenWidth <= 1024) {  
          let viewportMeta = document.querySelector('meta[name="viewport"]') as any;  
          if (!viewportMeta) {  
              viewportMeta = document.createElement('meta');  
              viewportMeta.name = "viewport";  
              document.head.appendChild(viewportMeta);  
          }  
          console.log(viewportMeta.content)
          // 2026-09-30：手机按真实视口响应布局，保留用户缩放并启用刘海屏安全区。
          viewportMeta.content = screenWidth <= 768 ? "width=device-width, initial-scale=1.0, viewport-fit=cover" : "width=device-width, initial-scale=0.9";
      }  
    }
    const maintenanceConfig = ref<SystemMaintenanceConfig>({ ...DEFAULT_MAINTENANCE_CONFIG })
    // 2026-09-08：ready 只表示已取得有效维护状态，读取失败保留独立重试状态。
    const maintenanceReady = ref(false)
    const maintenanceError = ref(false)
    const maintenanceChecking = ref(false)
    let maintenanceTimer = 0
    let appInitialized = false
    // 2026-09-09：业务就绪与维护状态独立；初始化失败释放重试，未完成前不使用机构缓存加载页面。
    const applicationReady=ref(false),applicationError=ref(false),applicationChecking=ref(false)
    watch(()=>[applicationReady.value,store.getters.orgId,store.getters.orgInfo],()=>applyClientSkin(resolveClientSkin(Number(store.getters.orgId),store.getters.orgInfo,applicationReady.value)),{immediate:true,deep:true,flush:'sync'})
    const syncLayout=()=>{
      const isPad=window.innerWidth<=1180
      if(store.getters.isPad!==isPad)store.commit('user/setIsPad',isPad)
    }
    syncLayout()
    window.addEventListener('resize',syncLayout,{passive:true})
    // 2026-09-06：页面维护保持开启；短期内存资格绑定本轮维护、账号和机构，刷新页面必须重新验证。
    const testerLogin=ref(false),testerTick=ref(0),testerRefreshing=ref(false)
    let testerClock=0,testerOperation=0,testerExpiryTimer=0,testerVerification=0,testerContextReady=false
    const tester=createMaintenanceTester(()=>({token:store.getters.token || '',customerId:Number(store.getters.userInfo?.id || 0),orgId:Number(store.getters.orgId || 0)}),async()=>{
      const response:any=await request({url:'customer/maintenanceAccess',method:'GET'})
      return response.data
    })
    const testerAllowed=computed(()=>{testerTick.value;store.getters.token;store.getters.userInfo;store.getters.orgId;return tester.active(maintenanceConfig.value)})
    const testerRetaining=computed(()=>{testerTick.value;return testerRefreshing.value && tester.canRevalidate(maintenanceConfig.value)})
    const exitMaintenanceTest=async()=>{
      testerOperation++;testerVerification++;testerRefreshing.value=false;tester.clear();testerLogin.value=false;testerTick.value++
      await store.dispatch('user/logout')
    }
    // 2026-09-08：新标签页先确认域名机构，再用有效登录向服务端复核；不从缓存恢复放行结论。
    const refreshTesterAccess=async()=>{
      const operation=++testerVerification
      testerRefreshing.value=true
      try{
        if(store.getters.token && !testerContextReady){
          const response:any=await sysRequest.getOrgId(extractHostnameAndPort(window.location.href))
          if(operation!==testerVerification)return null
          const orgId=Number(response.data?.orgId || 0)
          if(!Number.isSafeInteger(orgId) || orgId<=0)throw new Error('当前机构不可用')
          store.commit('user/setOrgId',orgId)
          testerContextReady=true
        }
        const allowed=await tester.verify(maintenanceConfig.value)
        if(operation!==testerVerification)return null
        testerTick.value++
        if(allowed)await initializeApplication()
        return allowed
      }catch(_error){
        if(operation!==testerVerification)return null
        tester.clear();testerTick.value++
        return false
      }finally{if(operation===testerVerification)testerRefreshing.value=false}
    }
    const verifyTesterLogin=async()=>{
      const operation=testerOperation
      const allowed=await refreshTesterAccess()
      if(allowed===null)return
      if(!allowed){
        if(operation!==testerOperation)return
        await exitMaintenanceTest();message.warning('该账号未获本轮维护测试资格，或资格已到期。已返回维护页。');return
      }
      if(operation!==testerOperation)return
      testerTick.value++;testerLogin.value=false
      await initializeApplication()
    }
    const beginTesterLogin=async()=>{
      const operation=++testerOperation
      testerVerification++;testerRefreshing.value=false;testerContextReady=false;tester.clear();testerTick.value++
      try{
        // 冷启动不能使用上次机构缓存登录，维护页只先读取当前域名对应的公开机构。
        const response:any=await sysRequest.getOrgId(extractHostnameAndPort(window.location.href))
        if(operation!==testerOperation)return
        const orgId=Number(response.data?.orgId || 0)
        if(!Number.isInteger(orgId) || orgId<=0)throw new Error('当前机构不可用，请联系平台。')
        await store.dispatch('user/logout')
        if(operation!==testerOperation)return
        store.commit('user/setOrgId',orgId)
        testerContextReady=true
        tester.begin();testerLogin.value=true
        window.clearTimeout(testerExpiryTimer)
        testerExpiryTimer=window.setTimeout(()=>{if(testerLogin.value)exitMaintenanceTest()},10*60*1000)
      }catch(error:any){message.warning(error?.message || '测试入口初始化失败，请稍后重试。')}
    }
    // 2026-09-08：个人资料正常换发 token 时立即复核；同步标记复核状态，保持当前页面不会被卸载重建。
    watch(()=>[store.getters.token,store.getters.userInfo?.id,store.getters.orgId],()=>{
      testerTick.value++
      if(!maintenanceReady.value || !maintenanceConfig.value.enabled || testerLogin.value || !testerContextReady)return
      if(!store.getters.token || !store.getters.userInfo?.id){
        testerVerification++;testerRefreshing.value=false;tester.clear();testerTick.value++;return
      }
      void refreshTesterAccess()
    },{flush:'sync'})

    const initializeApplication = async () => {
      if (appInitialized || maintenanceConfig.value.enabled && !testerAllowed.value) return
      appInitialized = true
      applicationChecking.value=true;applicationError.value=false
      try{
      await store.dispatch('user/getSettings')
      console.log(store.getters.settings)
      const hostname=extractHostnameAndPort(window.location.href)
      
      const res=await sysRequest.getOrgId(hostname) //.then(res=>{
      if(res.data){
        const orgId=Number(res.data.orgId)
        if(!Number.isSafeInteger(orgId) || orgId<=0 || !res.data.orgInfo || !Array.isArray(res.data.functions)) throw new Error('当前机构信息不完整')
        store.commit('user/setOrgId', orgId)
        console.log(store.getters.orgId)
        const fncsss= res.data.functions.reduce((acc,item)=>{
          if(!acc[item.functionName]){
            acc[item.functionName]=item
          }
          return acc
        },{})   
        // 2026-08-24：先保存机构基础功能，客户登录后再叠加VIP角色的可用范围。
        store.commit('user/setOrgPreviliges', fncsss)
        if(store.getters.userInfo?.id) await store.dispatch('user/refreshVipAccess')
        if(res.data.orgInfo.logoUrl) res.data.orgInfo.logoUrl=imgurl.value+'/'+res.data.orgInfo.logoUrl
        if(res.data.orgInfo.logoUrl1) res.data.orgInfo.logoUrl1=imgurl.value+'/'+res.data.orgInfo.logoUrl1
        if(res.data.orgInfo.settings) 
          res.data.orgInfo.settings=JSON.parse(res.data.orgInfo.settings)
        else{
          res.data.orgInfo.settings={alipay:false,offlinepay:false}
        }
        if(res.data.orgInfo.customerServiceUrl && !res.data.orgInfo.customerServiceUrl.includes('https')) 
        res.data.orgInfo.customerServiceUrl=imgurl.value+'/'+res.data.orgInfo.customerServiceUrl
        // 2026-08-23：保存服务端判定的全功能分店素材权限，供版型详情精确展示平面图。
        res.data.orgInfo.canViewPatternAdvancedMedia=res.data.canViewPatternAdvancedMedia===true
        // 2026-09-28：量体计价使用服务端独立的全功能分店标志，缺失时保留未知状态，不能当普通店免单。
        res.data.orgInfo.fullFunctionBranch=typeof res.data.fullFunctionBranch==='boolean'?res.data.fullFunctionBranch:undefined
        store.commit('user/setOrgInfo', res.data.orgInfo)
      }else{
        // 2026-08-12：公开机构解析失败即清空旧机构缓存并展示不可访问页，避免待审核分店复用上次 C 端数据。
        store.commit('user/setOrgId', 0)
        store.commit('user/setOrgPreviliges', {})
        store.commit('user/setOrgInfo', {})
        await router.replace({path: '/homeview'})
      }
      // })
      applyClientSkin(resolveClientSkin(Number(store.getters.orgId),store.getters.orgInfo,true));
      // setTimeout(()=>{
        //generateNewStyle(store.getters.theme)
        
      // },3000)
      // console.log(navigator.userAgent)
      setScale()
      const style = document.createElement('link')
      style.setAttribute('id', 'antcss')
      style.setAttribute('rel', 'stylesheet')
      style.setAttribute('href', '/antd.css')
  // style.innerText = data
      document.head.appendChild(style)
      //initWebSocket()
      applicationReady.value=true
      }catch(_error){
        appInitialized=false;applicationError.value=true
      }finally{applicationChecking.value=false}
    }

    const refreshMaintenance = async () => {
      if (maintenanceChecking.value) return
      maintenanceChecking.value = true
      try {
        maintenanceConfig.value = await loadPlatformMaintenance()
        maintenanceReady.value = true
        maintenanceError.value = false
      } catch (_error) {
        // 2026-09-08：首次失败保持业务关闭；已有有效状态时仅保留最近结果，等待重试。
        if (!maintenanceReady.value) maintenanceError.value = true
      } finally {
        maintenanceChecking.value = false
      }
      if (!maintenanceReady.value) return
      if (!maintenanceConfig.value.enabled){testerVerification++;testerRefreshing.value=false;tester.clear();testerLogin.value=false;testerTick.value++;await initializeApplication()}
      else if(!testerLogin.value){
        await refreshTesterAccess()
      }
    }

    const handleVisibilityChanged = () => {
      if (document.visibilityState === 'visible') refreshMaintenance()
    }
    // 2026-09-09: Startup and page restore share a non-destructive deployment check.
    let stopEntryUpdate:undefined|(()=>void)
    onMounted(async () => {
      // 2026-09-09：普通浏览页自动切换已就绪新版，免去更新确认，填写和支付期间延后。
      stopEntryUpdate=installWebEntryUpdate(router)
      document.addEventListener('visibilitychange', handleVisibilityChanged)
      // 2026-09-08：先建立轮询，避免首次请求或后续业务初始化失败中断维护重试。
      maintenanceTimer = window.setInterval(refreshMaintenance, 15000)
      testerClock=window.setInterval(()=>{testerTick.value++},1000)
      await refreshMaintenance()
    })
    onBeforeUnmount(() => {
      stopEntryUpdate?.()
      window.clearInterval(maintenanceTimer)
      window.removeEventListener('resize',syncLayout)
      window.clearInterval(testerClock);window.clearTimeout(testerExpiryTimer);testerVerification++;tester.clear()
      document.removeEventListener('visibilitychange', handleVisibilityChanged)
    })
    // watchEffect(() => {
    //   if (socketRef.value && socketRef.value.readyState !== WebSocket.CLOSED) {
    //     socketRef.value.close(); // 先关闭现有连接
    //     initWebSocket(); // 重新初始化 WebSocket
    //   }
    // });
    return {
      testerAllowed,testerLogin,testerRefreshing,testerRetaining,beginTesterLogin,verifyTesterLogin,exitMaintenanceTest,
      person,
      locale:lang,
      uiDirection: computed(() => displayLanguage.value === 'ug' ? 'rtl' : 'ltr'),
      maintenanceConfig,
      maintenanceReady,
      applicationReady,applicationError,applicationChecking,
      maintenanceError,
      maintenanceChecking,
      refreshMaintenance
    }
  }
})
